export const DECK_VELOCITY_THRESHOLD = 0.55;

export function resolveDeckSwipeDirection(deltaX: number, velocityX: number): "next" | "prev" {
  if (Math.abs(velocityX) >= DECK_VELOCITY_THRESHOLD) return velocityX < 0 ? "next" : "prev";
  return deltaX < 0 ? "next" : "prev";
}
